import React, { FunctionComponent } from 'react';

import { SingleYesNoStep } from 'scenes/common/components/Steps';
import { getHasPreExistingDamage } from 'scenes/motor/selectors';
import { MotorFullPageProps } from 'scenes/motor/types';

const STATE_KEY = 'hasPreExistingDamage';
const QUESTION = 'Does the car have any rust, hail, panel or accident damage?';
const HELP_TEXT = 'Not including minor chips and scratches.';

const PreExistingDamageStep: FunctionComponent<MotorFullPageProps> = ({
  funnelState,
  onNext,
}) => (
  <SingleYesNoStep
    question={QUESTION}
    stateKey={STATE_KEY}
    helpText={HELP_TEXT}
    defaultStateValue={getHasPreExistingDamage(funnelState)}
    onNext={onNext}
  />
);

export default PreExistingDamageStep;
